module.exports = __webpack_public_path__ + "src/assets/games/27/2166.jpg";